var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKaruncupDark({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2991,
    height: 1186,
    viewBox: "0 0 2991 1186",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2636.5 181H2988.5L2712 363.5L2504.5 508H2793.5C2912 515.805 2968.45 531.738 2957 690V929H2152.5C2036.31 941.424 1997.74 920.759 1964 847.5V332H2152.5V778H2793.5V690H2259.5V508L2636.5 181Z",
    fill: "#3EE7AF",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M354 188H2L278.5 370.5L486 515H197C78.5032 522.805 22.0546 538.738 33.5 697V936H838C954.191 948.424 992.76 927.759 1026.5 854.5V339H838V785H197V697H731V515L354 188Z",
    fill: "#3EE7AF",
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1846.5 824.5V466H1691.5V745C1689.02 768.478 1682.98 776.434 1659.5 776.5H1337.5C1303.31 781.378 1297.21 771.061 1294 745V466H1143.5V799.5C1146.82 890.007 1170.03 922.482 1271 929.5H1746C1804.67 915.534 1834.98 904.11 1846.5 824.5Z",
    fill: "#3EE7AF",
    stroke: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1200 971V1098.42C1258.06 1127.79 1309.71 1150.25 1358.87 1165.06V1040.44C1310.05 1024.95 1258.25 1001.68 1200 971Z",
    fill: "#3EE7AF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1790 1098.42V971C1757.88 988.302 1727.75 1003.1 1699.08 1015.45V1140.07C1727.68 1128.49 1757.83 1114.63 1790 1098.42Z",
    fill: "#3EE7AF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1439.8 1059.21V1182.64C1500.4 1190.33 1560.5 1184.96 1628.14 1165.06L1618.15 1044.87C1555.66 1062.9 1498.53 1067.42 1439.8 1059.21Z",
    fill: "#3EE7AF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1425.37 564.5H1510.25V374.458H1832.78L1753.29 321.462H1510.25V1H1425.37L1143 276.332V374.458H1425.37V564.5ZM1425.37 321.462H1216.7V276.332L1425.37 100.368V321.462Z",
    fill: "#3EE7AF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1425.37 374.458V564.5H1510.25V374.458M1425.37 374.458H1143V276.332L1425.37 1H1510.25V321.462M1425.37 374.458V321.462M1425.37 374.458H1510.25M1510.25 321.462H1753.29L1832.78 374.458H1510.25M1510.25 321.462H1425.37M1510.25 321.462V374.458M1425.37 321.462V100.368L1216.7 276.332V321.462H1425.37Z",
    stroke: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1713.95 297.448H1536.75V252.318H1679.59L1713.95 297.448Z",
    fill: "#3EE7AF",
    stroke: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M1650.61 228.719H1536.33V199.736H1628.44L1650.61 228.719Z",
    fill: "#3EE7AF",
    stroke: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M1600.09 170.754H1536.33V155.021H1587.73L1600.09 170.754Z",
    fill: "#3EE7AF",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKaruncupDark);
export default __webpack_public_path__ + "static/media/karuncup-dark.cb3e07dff79f96f214526a01d5512698.svg";
export { ForwardRef as ReactComponent };